/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataModelMigrationType {
    NEW_MODEL = 'newModel',
    BASE_NEW_MODEL = 'baseNewModel',
    EMPTY_MODEL = 'emptyModel',
    RELATED_MODEL = 'relatedModel',
}
